const SchoolTypes = {
  CareCenter: 246,
  PrivateSchool: 248,
  PublicSchool: 249,
  HeadStart: 250,
  Home: 251,
  Institutions: 349,
  YoungInstitutions: 1488,
};
export default SchoolTypes;
